<div class="container-fluid text-center py-4 mt-5 h-100 d-flex align-items-center">
  <div class="container">
    <img alt="not_found" src="../../../../assets/img/pagina-no-encontrada.png" height="70">
    <h6 class="mb-0 text-center mt-4">
      Ocurrió un error inesperado, por favor intente de nuevo más tarde
    </h6>
  </div>
</div>
